import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=218fd41a"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=218fd41a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports